export function isFocusable(element: Element): element is HTMLElement | SVGElement {
   return element instanceof HTMLElement || element instanceof SVGElement;
}

// Radix's order: the first control, links skipped, else the container itself,
// so a container of text and links still takes focus and Tab reaches the links.
export function focusFirst(container: HTMLElement, candidates = tabbables(container)) {
   focusControl(candidates.find(element => element.tagName !== 'A') ?? container);
}

export function focusControl(element: HTMLElement | SVGElement) {
   element.focus({ preventScroll: true });
   if (element instanceof HTMLInputElement) element.select();
}

// What Radix's focus scope counts as tabbable, in document order.
export function tabbables(container: HTMLElement) {
   return [...container.querySelectorAll('*')].filter(
      (element): element is HTMLElement | SVGElement =>
         isFocusable(element) &&
         element.tabIndex >= 0 &&
         !element.matches(':disabled, [hidden], input[type="hidden"]') &&
         isRendered(element)
   );
}

// jsdom has no checkVisibility.
function isRendered(element: Element) {
   return typeof element.checkVisibility !== 'function' || element.checkVisibility();
}
